export const Occupations = [
  { id: "church", name: "churchperson", color: "#463ee2" },
  { id: "craft", name: "craftsman", color: "#38BEC9" },
  { id: "diss", name: "dissident minister", color: "#fb9a99" },
  { id: "free", name: "free profession", color: "#e31a1c" },
  { id: "man", name: "manual worker", color: "#fdbf6f" },
  { id: "qual", name: "manufacturer or qualified worker", color: "#ff7f00" },
  { id: "merch", name: "merchant", color: "#33a02c" },
  { id: "offi", name: "official", color: "#000000" },
  { id: "serv", name: "servant", color: "#bc80bd" },
  { id: "sp", name: "service provider", color: "#b15928" },
  { id: "undef_occ", name: "unknown", color: "#E8E6E1" },
];
